export default __webpack_public_path__ + "79c437e37581600133fa15f236f993fb.svg";